import * as React from "react";
import { ConfirmSignUp } from "aws-amplify-react";

import { withSectionBodyNotes } from "./section-body-notes";
import { stripRequiredMarks } from "./strip-required-marks";
import { renderStockScreen } from "./stock-screen";

/**
 * The stock Amplify v3 Confirm Sign Up screen with a note about where the
 * confirmation code lands — this is the step new practitioners most often
 * stall on, and the code routinely gets filtered.
 */
export class LabSmartsConfirmSignUp extends ConfirmSignUp {
  showComponent(theme: any): JSX.Element {
    return stripRequiredMarks(
      withSectionBodyNotes(
        renderStockScreen(this, ConfirmSignUp, () =>
          super.showComponent(theme),
        ),
        "confirm-sign-up-body-section",
        (fields) =>
          fields.concat(
            <div className="ls-auth-hint" key="ls-confirmation-code-note">
              The code is emailed as soon as the account is created. If it has
              not arrived within a few minutes, check the{" "}
              <strong>spam or junk folder</strong> before requesting a new one.
            </div>,
          ),
      ),
    ) as JSX.Element;
  }
}
